import React from "react";
import { useTranslation } from "react-i18next";

const ModeToggle = ({ viewMode, onModeChange }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center bg-gray-100 rounded-lg p-1">
      <button
        onClick={() => onModeChange("manage")}
        className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
          viewMode === "manage" 
            ? "bg-white text-blue-600 shadow-sm" 
            : "text-gray-500 hover:text-gray-700"
        }`}
      >
        {t("mealAvailability.manageMode")}
      </button>
      <button
        onClick={() => onModeChange("view")}
        className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
          viewMode === "view" 
            ? "bg-white text-blue-600 shadow-sm" 
            : "text-gray-500 hover:text-gray-700"
        }`}
      >
        {t("mealAvailability.viewMode")}
      </button>
    </div>
  );
};

export default ModeToggle;
